export enum PaymentMethod {
  Cash = 0,
  Card = 1,
}

export const paymentMethodDisplayStatus = (paymentMethod: PaymentMethod) => {
  switch (paymentMethod) {
    case PaymentMethod.Cash:
      return 'Cash';
    case PaymentMethod.Card:
      return 'Card';
  }
};
